<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_sasv.mass_suspend_title')">
    <template #content>
      <v-container class="mass-disable-sasv">
        <v-row class="flex-grow-0">
          <v-col cols="8">
            <v-file-input :label="$t('admin_sasv.mass_suspend_csv')"
                          accept="text/csv"
                          hint="ACCEPTED FILE FORMAT: CSV"
                          persistent-hint
                          clearable
                          v-model="csv"></v-file-input>
          </v-col>
          <v-col cols="4">
            <v-btn block
                   color="primary"
                   :disabled="!csv"
                   @click="uploadCsv">
              SELECT
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table :items="records"
                      :headers="headers"
                      v-model="selectedSasv"
                      :footer-props="{itemsPerPageOptions: [10, 20, 50], showFirstLastPage: true}"
                      fixed-header
                      show-select
                      class="mass-disable-list--table">
          <template #item.id_type="{value}">
            {{ $t(`id_type.${value}`) }}
          </template>
          <template #item.validated_at="{value}">
            {{ value ? $parseDate(value, 'yyyy-MM-dd') : '' }}
          </template>
          <template #item.status="{value}">
            {{ $t(`sasv_status.${value}`) }}
          </template>
        </v-data-table>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="confirmSuspend"
               class="mr-3"
               depressed
               large
               :disabled="selectedSasv.length === 0">
          {{ $t('admin_sasv.suspend') }}
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";

export default {
  name: 'MassDisableSasvModal',
  components: {BGModal},
  props: {
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          csv.value = null;
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    const csv = ref(null);
    const uploadCsv = function () {
      let reader = new FileReader();
      reader.onload = function (event) {
        octopusNo.value = event.target.result.split('\r\n');

        getSasv();
      };
      reader.readAsText(csv.value);
    }

    const octopusNo = ref([]);

    const getSasv = function () {
      root.$callAPI('sasv/admin/', {
        filters: {
          octopus_no: octopusNo.value,
          status: 'APPROVED',
        }
      }, function (response) {
        records.value = response.body.sasvs;
      });
    };
    const records = ref([]);
    const headers = ref([
      {text: root.$t('admin_sasv.octopus_no'), value: 'octopus_no'},
      {text: root.$t('admin_sasv.surname'), value: 'surname'},
      {text: root.$t('admin_sasv.given_name'), value: 'given_name'},
      {text: root.$t('admin_sasv.id_type'), value: 'id_type'},
      {text: root.$t('admin_sasv.company'), value: 'company.name'},
      {text: root.$t('admin_sasv.other_company_name'), value: 'other_company_name'},
      {text: root.$t('admin_sasv.status'), value: 'status', sortable: false},
      {text: root.$t('admin_sasv.validated_at'), value: 'validated_at', boolean: false},
    ]);

    const selectedSasv = ref([]);
    const confirmSuspend = function () {
      if (confirm(root.$t('admin_sasv.suspend_confirm_msg'))) {
        root.$callAPI('sasv/admin/suspend/', {ids: selectedSasv.value.map((s) => s.id)}, function (response) {
          getSasv();
        });
      }
    }

    return {
      dialogShown,
      cancel,

      csv,
      uploadCsv,

      octopusNo,
      records,
      headers,

      selectedSasv,
      confirmSuspend,
    }
  }
}
</script>

<style lang="less">
.mass-disable-sasv {
  height: 100%;
  display: flex;
  flex-direction: column;

  .mass-disable-list--table {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;

    .v-data-table__wrapper {
      flex: 1 1 0;
      overflow-y: auto;
    }

    .v-data-footer {
      margin-right: 0 !important;
    }
  }
}
</style>
